'use client';
import React, { useLayoutEffect } from 'react';
import { gsap } from 'gsap';

function Header() {
  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=1');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    return () => tl.kill();
  }, []);

  return (
    <div className="header page-header section-padding">
      <div className="container pt-100">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <div className="caption">
              <h6 className="sub-title main-color mb-15">Meet Our Team</h6>
              <h1 className="fz-55 fw-700 mb-20">
                The Creative Minds & Innovators Behind <span className="fw-300">Aashway</span>
              </h1>
              <p className="fz-18 opacity-8 max-w-700 margin-auto">
                A diverse group of engineers, designers, strategists, and creators collaborating to deliver high-impact digital experiences.
              </p>
              <div className="mt-30">
                <a href="/">Home</a>
                <span className="padding-rl-20">|</span>
                <span className="main-color">Our Team</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
